// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btndoweload {
    background-color: #F3903F; /* Orange */
    color: white; /* White text */
    font-weight: semibold;
    padding: 5px 5px;
      size: 16px;
      height: 40px;
    border-radius: 8px;
    border: none;
    transition:  0.3s ease, transform 0.2s ease;
  }
  .btn-upload {
    background-color: transparent; /* Transparent background */
    color: #F3903F; /* Orange text */
    font-weight: semibold;
    padding: 5px 5px;
    size: 16px;
    height: 40px;
    border-radius: 8px;
    border: 2px solid #F3903F; /* Orange border */
    transition: 0.3s ease, transform 0.2s ease;
  }

  .btn-upload:hover {
    background-color: #F3903F; /* Orange background on hover */
    color: white; /* White text on hover */
  }
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .table-container {
    width: 100%;
    margin: 0;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .table-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }

  .styled-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    background-color: white;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 12px;
   
    border-bottom: 1px solid #ddd;
  }
  
  .styled-table th {
    background-color: #f2f2f2;
    cursor: pointer;
  }
  
  .styled-table th.sortable-header:hover {
    background-color: #eaeef2;
  }`, "",{"version":3,"sources":["webpack://./src/pages/User/style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,WAAW;IACtC,YAAY,EAAE,eAAe;IAC7B,qBAAqB;IACrB,gBAAgB;MACd,UAAU;MACV,YAAY;IACd,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,6BAA6B,EAAE,2BAA2B;IAC1D,cAAc,EAAE,gBAAgB;IAChC,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,kBAAkB;IAC7C,0CAA0C;EAC5C;;EAEA;IACE,yBAAyB,EAAE,+BAA+B;IAC1D,YAAY,EAAE,wBAAwB;EACxC;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;;IAEb,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".btndoweload {\r\n    background-color: #F3903F; /* Orange */\r\n    color: white; /* White text */\r\n    font-weight: semibold;\r\n    padding: 5px 5px;\r\n      size: 16px;\r\n      height: 40px;\r\n    border-radius: 8px;\r\n    border: none;\r\n    transition:  0.3s ease, transform 0.2s ease;\r\n  }\r\n  .btn-upload {\r\n    background-color: transparent; /* Transparent background */\r\n    color: #F3903F; /* Orange text */\r\n    font-weight: semibold;\r\n    padding: 5px 5px;\r\n    size: 16px;\r\n    height: 40px;\r\n    border-radius: 8px;\r\n    border: 2px solid #F3903F; /* Orange border */\r\n    transition: 0.3s ease, transform 0.2s ease;\r\n  }\r\n\r\n  .btn-upload:hover {\r\n    background-color: #F3903F; /* Orange background on hover */\r\n    color: white; /* White text on hover */\r\n  }\r\n  .table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .table th,\r\n  .table td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .table-container {\r\n    width: 100%;\r\n    margin: 0;\r\n    padding: 10px;\r\n    background-color: #f9f9f9;\r\n    border-radius: 8px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .table-title {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    font-size: 24px;\r\n    color: #333;\r\n  }\r\n\r\n  .styled-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-bottom: 20px;\r\n    background-color: white;\r\n  }\r\n  \r\n  .styled-table th,\r\n  .styled-table td {\r\n    padding: 12px;\r\n   \r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n  \r\n  .styled-table th {\r\n    background-color: #f2f2f2;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .styled-table th.sortable-header:hover {\r\n    background-color: #eaeef2;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
